module.exports = __webpack_public_path__ + "img/change.430e341e.svg";